import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = ({ currentLang }) => {
  const navigate = useNavigate();

  const content = {
    tr: {
      title: "404 - Sayfa Bulunamadı",
      description: "Aradığınız sayfa mevcut değil veya taşınmış olabilir.",
      button: "Ana Sayfaya Dön"
    },
    en: {
      title: "404 - Page Not Found",
      description: "The page you're looking for doesn't exist or has been moved.",
      button: "Back to Home"
    }
  };

  const t = content[currentLang];

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1>{t.title}</h1>
        <p>{t.description}</p>
        <button 
          className="back-home-button"
          onClick={() => navigate('/')}
        >
          {t.button}
        </button>
      </div>
    </div>
  );
};

export default NotFound; 